import { ref as mt, isRef as vt, watch as Dt, onMounted as Tt, onUnmounted as Yt } from "vue";
var B = function() {
  return B = Object.assign || function(t) {
    for (var r, e = 1, c = arguments.length; e < c; e++) for (var g in r = arguments[e]) Object.prototype.hasOwnProperty.call(r, g) && (t[g] = r[g]);
    return t;
  }, B.apply(this, arguments);
};
function xt(t, r, e) {
  for (var c, g = 0, d = r.length; g < d; g++) !c && g in r || (c || (c = Array.prototype.slice.call(r, 0, g)), c[g] = r[g]);
  return t.concat(c || Array.prototype.slice.call(r));
}
function ht(t) {
  return Array.prototype.slice.call(t);
}
function gt(t, r) {
  var e = Math.floor(t);
  return e === r || e + 1 === r ? t : r;
}
function yt() {
  return Date.now();
}
function ft(t, r, e) {
  if (r = "data-keen-slider-" + r, e === null) return t.removeAttribute(r);
  t.setAttribute(r, e || "");
}
function ot(t, r) {
  return r = r || document, typeof t == "function" && (t = t(r)), Array.isArray(t) ? t : typeof t == "string" ? ht(r.querySelectorAll(t)) : t instanceof HTMLElement ? [t] : t instanceof NodeList ? ht(t) : [];
}
function tt(t) {
  t.raw && (t = t.raw), t.cancelable && !t.defaultPrevented && t.preventDefault();
}
function et(t) {
  t.raw && (t = t.raw), t.stopPropagation && t.stopPropagation();
}
function kt() {
  var t = [];
  return { add: function(r, e, c, g) {
    r.addListener ? r.addListener(c) : r.addEventListener(e, c, g), t.push([r, e, c, g]);
  }, input: function(r, e, c, g) {
    this.add(r, e, /* @__PURE__ */ function(d) {
      return function(o) {
        o.nativeEvent && (o = o.nativeEvent);
        var D = o.changedTouches || [], M = o.targetTouches || [], h = o.detail && o.detail.x ? o.detail : null;
        return d({ id: h ? h.identifier ? h.identifier : "i" : M[0] ? M[0] ? M[0].identifier : "e" : "d", idChanged: h ? h.identifier ? h.identifier : "i" : D[0] ? D[0] ? D[0].identifier : "e" : "d", raw: o, x: h && h.x ? h.x : M[0] ? M[0].screenX : h ? h.x : o.pageX, y: h && h.y ? h.y : M[0] ? M[0].screenY : h ? h.y : o.pageY });
      };
    }(c), g);
  }, purge: function() {
    t.forEach(function(r) {
      r[0].removeListener ? r[0].removeListener(r[2]) : r[0].removeEventListener(r[1], r[2], r[3]);
    }), t = [];
  } };
}
function pt(t, r, e) {
  return Math.min(Math.max(t, r), e);
}
function q(t) {
  return (t > 0 ? 1 : 0) - (t < 0 ? 1 : 0) || +t;
}
function Mt(t) {
  var r = t.getBoundingClientRect();
  return { height: gt(r.height, t.offsetHeight), width: gt(r.width, t.offsetWidth) };
}
function V(t, r, e, c) {
  var g = t && t[r];
  return g == null ? e : c && typeof g == "function" ? g() : g;
}
function j(t) {
  return Math.round(1e6 * t) / 1e6;
}
function Ct(t) {
  var r, e, c, g, d, o;
  function D(T) {
    o || (o = T), M(!0);
    var L = T - o;
    L > c && (L = c);
    var k = g[e];
    if (k[3] < L) return e++, D(T);
    var E = k[2], a = k[4], i = k[0], s = k[1] * (0, k[5])(a === 0 ? 1 : (L - E) / a);
    if (s && t.track.to(i + s), L < c) return y();
    o = null, M(!1), h(null), t.emit("animationEnded");
  }
  function M(T) {
    r.active = T;
  }
  function h(T) {
    r.targetIdx = T;
  }
  function y() {
    var T;
    T = D, d = window.requestAnimationFrame(T);
  }
  function O() {
    var T;
    T = d, window.cancelAnimationFrame(T), M(!1), h(null), o && t.emit("animationStopped"), o = null;
  }
  return r = { active: !1, start: function(T) {
    if (O(), t.track.details) {
      var L = 0, k = t.track.details.position;
      e = 0, c = 0, g = T.map(function(E) {
        var a, i = Number(k), s = (a = E.earlyExit) !== null && a !== void 0 ? a : E.duration, u = E.easing, I = E.distance * u(s / E.duration) || 0;
        k += I;
        var Y = c;
        return c += s, L += I, [i, E.distance, Y, c, E.duration, u];
      }), h(t.track.distToIdx(L)), y(), t.emit("animationStarted");
    }
  }, stop: O, targetIdx: null };
}
function Lt(t) {
  var r, e, c, g, d, o, D, M, h, y, O, T, L, k, E = 1 / 0, a = [], i = null, s = 0;
  function u(p) {
    U(s + p);
  }
  function I(p) {
    var f = Y(s + p).abs;
    return w(f) ? f : null;
  }
  function Y(p) {
    var f = Math.floor(Math.abs(j(p / e))), n = j((p % e + e) % e);
    n === e && (n = 0);
    var b = q(p), m = D.indexOf(xt([], D).reduce(function(A, C) {
      return Math.abs(C - n) < Math.abs(A - n) ? C : A;
    })), x = m;
    return b < 0 && f++, m === o && (x = 0, f += b > 0 ? 1 : -1), { abs: x + f * o * b, origin: m, rel: x };
  }
  function S(p, f, n) {
    var b;
    if (f || !F()) return l(p, n);
    if (!w(p)) return null;
    var m = Y(n ?? s), x = m.abs, A = p - m.rel, C = x + A;
    b = l(C);
    var $ = l(C - o * q(A));
    return ($ !== null && Math.abs($) < Math.abs(b) || b === null) && (b = $), j(b);
  }
  function l(p, f) {
    if (f == null && (f = j(s)), !w(p) || p === null) return null;
    p = Math.round(p);
    var n = Y(f), b = n.abs, m = n.rel, x = n.origin, A = P(p), C = (f % e + e) % e, $ = D[x], R = Math.floor((p - (b - m)) / o) * e;
    return j($ - C - $ + D[A] + R + (x === o ? e : 0));
  }
  function w(p) {
    return z(p) === p;
  }
  function z(p) {
    return pt(p, h, y);
  }
  function F() {
    return g.loop;
  }
  function P(p) {
    return (p % o + o) % o;
  }
  function U(p) {
    var f;
    f = p - s, a.push({ distance: f, timestamp: yt() }), a.length > 6 && (a = a.slice(-6)), s = j(p);
    var n = v().abs;
    if (n !== i) {
      var b = i !== null;
      i = n, b && t.emit("slideChanged");
    }
  }
  function v(p) {
    var f = p ? null : function() {
      if (o) {
        var n = F(), b = n ? (s % e + e) % e : s, m = (n ? s % e : s) - d[0][2], x = 0 - (m < 0 && n ? e - Math.abs(m) : m), A = 0, C = Y(s), $ = C.abs, R = C.rel, W = d[R][2], N = d.map(function(Z, ut) {
          var H = x + A;
          (H < 0 - Z[0] || H > 1) && (H += (Math.abs(H) > e - 1 && n ? e : 0) * q(-H));
          var G = ut - R, J = q(G), X = G + $;
          n && (J === -1 && H > W && (X += o), J === 1 && H < W && (X -= o), O !== null && X < O && (H += e), T !== null && X > T && (H -= e));
          var Q = H + Z[0] + Z[1], K = Math.max(H >= 0 && Q <= 1 ? 1 : Q < 0 || H > 1 ? 0 : H < 0 ? Math.min(1, (Z[0] + H) / Z[0]) : (1 - H) / Z[0], 0);
          return A += Z[0] + Z[1], { abs: X, distance: g.rtl ? -1 * H + 1 - Z[0] : H, portion: K, size: Z[0] };
        });
        return $ = z($), R = P($), { abs: z($), length: c, max: k, maxIdx: y, min: L, minIdx: h, position: s, progress: n ? b / e : s / c, rel: R, slides: N, slidesLength: e };
      }
    }();
    return r.details = f, t.emit("detailsChanged"), f;
  }
  return r = { absToRel: P, add: u, details: null, distToIdx: I, idxToDist: S, init: function(p) {
    if (function() {
      if (g = t.options, d = (g.trackConfig || []).map(function(m) {
        return [V(m, "size", 1), V(m, "spacing", 0), V(m, "origin", 0)];
      }), o = d.length) {
        e = j(d.reduce(function(m, x) {
          return m + x[0] + x[1];
        }, 0));
        var n, b = o - 1;
        c = j(e + d[0][2] - d[b][0] - d[b][2] - d[b][1]), D = d.reduce(function(m, x) {
          if (!m) return [0];
          var A = d[m.length - 1], C = m[m.length - 1] + (A[0] + A[2]) + A[1];
          return C -= x[2], m[m.length - 1] > C && (C = m[m.length - 1]), C = j(C), m.push(C), (!n || n < C) && (M = m.length - 1), n = C, m;
        }, null), c === 0 && (M = 0), D.push(j(e));
      }
    }(), !o) return v(!0);
    var f;
    (function() {
      var n = t.options.range, b = t.options.loop;
      O = h = b ? V(b, "min", -1 / 0) : 0, T = y = b ? V(b, "max", E) : M;
      var m = V(n, "min", null), x = V(n, "max", null);
      m !== null && (h = m), x !== null && (y = x), L = h === -1 / 0 ? h : t.track.idxToDist(h || 0, !0, 0), k = y === E ? y : S(y, !0, 0), x === null && (T = y), V(n, "align", !1) && y !== E && d[P(y)][2] === 0 && (k -= 1 - d[P(y)][0], y = I(k - s)), L = j(L), k = j(k);
    })(), f = p, Number(f) === f ? u(l(z(p))) : v();
  }, to: U, velocity: function() {
    var p = yt(), f = a.reduce(function(n, b) {
      var m = b.distance, x = b.timestamp;
      return p - x > 200 || (q(m) !== q(n.distance) && n.distance && (n = { distance: 0, lastTimestamp: 0, time: 0 }), n.time && (n.distance += m), n.lastTimestamp && (n.time += x - n.lastTimestamp), n.lastTimestamp = x), n;
    }, { distance: 0, lastTimestamp: 0, time: 0 });
    return f.distance / f.time || 0;
  } };
}
function Et(t) {
  var r, e, c, g, d, o, D, M;
  function h(i) {
    return 2 * i;
  }
  function y(i) {
    return pt(i, D, M);
  }
  function O(i) {
    return 1 - Math.pow(1 - i, 3);
  }
  function T() {
    return c ? t.track.velocity() : 0;
  }
  function L() {
    a();
    var i = t.options.mode === "free-snap", s = t.track, u = T();
    g = q(u);
    var I = t.track.details, Y = [];
    if (u || !i) {
      var S = k(u), l = S.dist, w = S.dur;
      if (w = h(w), l *= g, i) {
        var z = s.idxToDist(s.distToIdx(l), !0);
        z && (l = z);
      }
      Y.push({ distance: l, duration: w, easing: O });
      var F = I.position, P = F + l;
      if (P < d || P > o) {
        var U = P < d ? d - F : o - F, v = 0, p = u;
        if (q(U) === g) {
          var f = Math.min(Math.abs(U) / Math.abs(l), 1), n = function(x) {
            return 1 - Math.pow(1 - x, 1 / 3);
          }(f) * w;
          Y[0].earlyExit = n, p = u * (1 - f);
        } else Y[0].earlyExit = 0, v += U;
        var b = k(p, 100), m = b.dist * g;
        t.options.rubberband && (Y.push({ distance: m, duration: h(b.dur), easing: O }), Y.push({ distance: -m + v, duration: 500, easing: O }));
      }
      t.animator.start(Y);
    } else t.moveToIdx(y(I.abs), !0, { duration: 500, easing: function(x) {
      return 1 + --x * x * x * x * x;
    } });
  }
  function k(i, s) {
    s === void 0 && (s = 1e3);
    var u = 147e-9 + (i = Math.abs(i)) / s;
    return { dist: Math.pow(i, 2) / u, dur: i / u };
  }
  function E() {
    var i = t.track.details;
    i && (d = i.min, o = i.max, D = i.minIdx, M = i.maxIdx);
  }
  function a() {
    t.animator.stop();
  }
  t.on("updated", E), t.on("optionsChanged", E), t.on("created", E), t.on("dragStarted", function() {
    c = !1, a(), r = e = t.track.details.abs;
  }), t.on("dragChecked", function() {
    c = !0;
  }), t.on("dragEnded", function() {
    var i = t.options.mode;
    i === "snap" && function() {
      var s = t.track, u = t.track.details, I = u.position, Y = q(T());
      (I > o || I < d) && (Y = 0);
      var S = r + Y;
      u.slides[s.absToRel(S)].portion === 0 && (S -= Y), r !== e && (S = e), q(s.idxToDist(S, !0)) !== Y && (S += Y), S = y(S);
      var l = s.idxToDist(S, !0);
      t.animator.start([{ distance: l, duration: 500, easing: function(w) {
        return 1 + --w * w * w * w * w;
      } }]);
    }(), i !== "free" && i !== "free-snap" || L();
  }), t.on("dragged", function() {
    e = t.track.details.abs;
  });
}
function At(t) {
  var r, e, c, g, d, o, D, M, h, y, O, T, L, k, E, a, i, s, u = kt();
  function I(v) {
    if (o && M === v.id) {
      var p = w(v);
      if (h) {
        if (!l(v)) return S(v);
        y = p, h = !1, t.emit("dragChecked");
      }
      if (a) return y = p;
      tt(v);
      var f = function(b) {
        if (i === -1 / 0 && s === 1 / 0) return b;
        var m = t.track.details, x = m.length, A = m.position, C = pt(b, i - A, s - A);
        if (x === 0) return 0;
        if (!t.options.rubberband) return C;
        if (A <= s && A >= i || A < i && e > 0 || A > s && e < 0) return b;
        var $ = (A < i ? A - i : A - s) / x, R = g * x, W = Math.abs($ * R), N = Math.max(0, 1 - W / d * 2);
        return N * N * b;
      }(D(y - p) / g * c);
      e = q(f);
      var n = t.track.details.position;
      (n > i && n < s || n === i && e > 0 || n === s && e < 0) && et(v), O += f, !T && Math.abs(O * g) > 5 && (T = !0), t.track.add(f), y = p, t.emit("dragged");
    }
  }
  function Y(v) {
    !o && t.track.details && t.track.details.length && (O = 0, o = !0, T = !1, h = !0, M = v.id, l(v), y = w(v), t.emit("dragStarted"));
  }
  function S(v) {
    o && M === v.idChanged && (o = !1, t.emit("dragEnded"));
  }
  function l(v) {
    var p = z(), f = p ? v.y : v.x, n = p ? v.x : v.y, b = L !== void 0 && k !== void 0 && Math.abs(k - n) <= Math.abs(L - f);
    return L = f, k = n, b;
  }
  function w(v) {
    return z() ? v.y : v.x;
  }
  function z() {
    return t.options.vertical;
  }
  function F() {
    g = t.size, d = z() ? window.innerHeight : window.innerWidth;
    var v = t.track.details;
    v && (i = v.min, s = v.max);
  }
  function P(v) {
    T && (et(v), tt(v));
  }
  function U() {
    if (u.purge(), t.options.drag && !t.options.disabled) {
      var v;
      v = t.options.dragSpeed || 1, D = typeof v == "function" ? v : function(f) {
        return f * v;
      }, c = t.options.rtl ? -1 : 1, F(), r = t.container, function() {
        var f = "data-keen-slider-clickable";
        ot("[".concat(f, "]:not([").concat(f, "=false])"), r).map(function(n) {
          u.add(n, "dragstart", et), u.add(n, "mousedown", et), u.add(n, "touchstart", et);
        });
      }(), u.add(r, "dragstart", function(f) {
        tt(f);
      }), u.add(r, "click", P, { capture: !0 }), u.input(r, "ksDragStart", Y), u.input(r, "ksDrag", I), u.input(r, "ksDragEnd", S), u.input(r, "mousedown", Y), u.input(r, "mousemove", I), u.input(r, "mouseleave", S), u.input(r, "mouseup", S), u.input(r, "touchstart", Y, { passive: !0 }), u.input(r, "touchmove", I, { passive: !1 }), u.input(r, "touchend", S), u.input(r, "touchcancel", S), u.add(window, "wheel", function(f) {
        o && tt(f);
      });
      var p = "data-keen-slider-scrollable";
      ot("[".concat(p, "]:not([").concat(p, "=false])"), t.container).map(function(f) {
        return function(n) {
          var b;
          u.input(n, "touchstart", function(m) {
            b = w(m), a = !0, E = !0;
          }, { passive: !0 }), u.input(n, "touchmove", function(m) {
            var x = z(), A = x ? n.scrollHeight - n.clientHeight : n.scrollWidth - n.clientWidth, C = b - w(m), $ = x ? n.scrollTop : n.scrollLeft, R = x && n.style.overflowY === "scroll" || !x && n.style.overflowX === "scroll";
            if (b = w(m), (C < 0 && $ > 0 || C > 0 && $ < A) && E && R) return a = !0;
            E = !1, tt(m), a = !1;
          }), u.input(n, "touchend", function() {
            a = !1;
          });
        }(f);
      });
    }
  }
  t.on("updated", F), t.on("optionsChanged", U), t.on("created", U), t.on("destroyed", u.purge);
}
function St(t) {
  var r, e, c = null;
  function g(L, k, E) {
    t.animator.active ? o(L, k, E) : requestAnimationFrame(function() {
      return o(L, k, E);
    });
  }
  function d() {
    g(!1, !1, e);
  }
  function o(L, k, E) {
    var a = 0, i = t.size, s = t.track.details;
    if (s && r) {
      var u = s.slides;
      r.forEach(function(I, Y) {
        if (L) !c && k && M(I, null, E), h(I, null, E);
        else {
          if (!u[Y]) return;
          var S = u[Y].size * i;
          !c && k && M(I, S, E), h(I, u[Y].distance * i - a, E), a += S;
        }
      });
    }
  }
  function D(L) {
    return t.options.renderMode === "performance" ? Math.round(L) : L;
  }
  function M(L, k, E) {
    var a = E ? "height" : "width";
    k !== null && (k = D(k) + "px"), L.style["min-" + a] = k, L.style["max-" + a] = k;
  }
  function h(L, k, E) {
    if (k !== null) {
      k = D(k);
      var a = E ? k : 0;
      k = "translate3d(".concat(E ? 0 : k, "px, ").concat(a, "px, 0)");
    }
    L.style.transform = k, L.style["-webkit-transform"] = k;
  }
  function y() {
    r && (o(!0, !0, e), r = null), t.on("detailsChanged", d, !0);
  }
  function O() {
    g(!1, !0, e);
  }
  function T() {
    y(), e = t.options.vertical, t.options.disabled || t.options.renderMode === "custom" || (c = V(t.options.slides, "perView", null) === "auto", t.on("detailsChanged", d), (r = t.slides).length && O());
  }
  t.on("created", T), t.on("optionsChanged", T), t.on("beforeOptionsChanged", function() {
    y();
  }), t.on("updated", O), t.on("destroyed", y);
}
function zt(t, r) {
  return function(e) {
    var c, g, d, o, D, M = kt();
    function h(l) {
      var w;
      ft(e.container, "reverse", (w = e.container, window.getComputedStyle(w, null).getPropertyValue("direction") !== "rtl" || l ? null : "")), ft(e.container, "v", e.options.vertical && !l ? "" : null), ft(e.container, "disabled", e.options.disabled && !l ? "" : null);
    }
    function y() {
      O() && a();
    }
    function O() {
      var l = null;
      if (o.forEach(function(z) {
        z.matches && (l = z.__media);
      }), l === c) return !1;
      c || e.emit("beforeOptionsChanged"), c = l;
      var w = l ? d.breakpoints[l] : d;
      return e.options = B(B({}, d), w), h(), Y(), S(), s(), !0;
    }
    function T(l) {
      var w = Mt(l);
      return (e.options.vertical ? w.height : w.width) / e.size || 1;
    }
    function L() {
      return e.options.trackConfig.length;
    }
    function k(l) {
      for (var w in c = !1, d = B(B({}, r), l), M.purge(), g = e.size, o = [], d.breakpoints || []) {
        var z = window.matchMedia(w);
        z.__media = w, o.push(z), M.add(z, "change", y);
      }
      M.add(window, "orientationchange", I), M.add(window, "resize", u), O();
    }
    function E(l) {
      e.animator.stop();
      var w = e.track.details;
      e.track.init(l ?? (w ? w.abs : 0));
    }
    function a(l) {
      E(l), e.emit("optionsChanged");
    }
    function i(l, w) {
      if (l) return k(l), void a(w);
      Y(), S();
      var z = L();
      s(), L() !== z ? a(w) : E(w), e.emit("updated");
    }
    function s() {
      var l = e.options.slides;
      if (typeof l == "function") return e.options.trackConfig = l(e.size, e.slides);
      for (var w = e.slides, z = w.length, F = typeof l == "number" ? l : V(l, "number", z, !0), P = [], U = V(l, "perView", 1, !0), v = V(l, "spacing", 0, !0) / e.size || 0, p = U === "auto" ? v : v / U, f = V(l, "origin", "auto"), n = 0, b = 0; b < F; b++) {
        var m = U === "auto" ? T(w[b]) : 1 / U - v + p, x = f === "center" ? 0.5 - m / 2 : f === "auto" ? 0 : f;
        P.push({ origin: x, size: m, spacing: v }), n += m;
      }
      if (n += v * (F - 1), f === "auto" && !e.options.loop && U !== 1) {
        var A = 0;
        P.map(function(C) {
          var $ = n - A;
          return A += C.size + v, $ >= 1 || (C.origin = 1 - $ - (n > 1 ? 0 : 1 - n)), C;
        });
      }
      e.options.trackConfig = P;
    }
    function u() {
      Y();
      var l = e.size;
      e.options.disabled || l === g || (g = l, i());
    }
    function I() {
      u(), setTimeout(u, 500), setTimeout(u, 2e3);
    }
    function Y() {
      var l = Mt(e.container);
      e.size = (e.options.vertical ? l.height : l.width) || 1;
    }
    function S() {
      e.slides = ot(e.options.selector, e.container);
    }
    e.container = (D = ot(t, document)).length ? D[0] : null, e.destroy = function() {
      M.purge(), e.emit("destroyed"), h(!0);
    }, e.prev = function() {
      e.moveToIdx(e.track.details.abs - 1, !0);
    }, e.next = function() {
      e.moveToIdx(e.track.details.abs + 1, !0);
    }, e.update = i, k(e.options);
  };
}
var It = function(t, r, e) {
  try {
    return function(c, g) {
      var d, o = {};
      return d = { emit: function(D) {
        o[D] && o[D].forEach(function(h) {
          h(d);
        });
        var M = d.options && d.options[D];
        M && M(d);
      }, moveToIdx: function(D, M, h) {
        var y = d.track.idxToDist(D, M);
        if (y) {
          var O = d.options.defaultAnimation;
          d.animator.start([{ distance: y, duration: V(h || O, "duration", 500), easing: V(h || O, "easing", function(T) {
            return 1 + --T * T * T * T * T;
          }) }]);
        }
      }, on: function(D, M, h) {
        h === void 0 && (h = !1), o[D] || (o[D] = []);
        var y = o[D].indexOf(M);
        y > -1 ? h && delete o[D][y] : h || o[D].push(M);
      }, options: c }, function() {
        if (d.track = Lt(d), d.animator = Ct(d), g) for (var D = 0, M = g; D < M.length; D++) (0, M[D])(d);
        d.track.init(d.options.initial || 0), d.emit("created");
      }(), d;
    }(r, xt([zt(t, { drag: !0, mode: "snap", renderMode: "precision", rubberband: !0, selector: ".keen-slider__slide" }), St, At, Et], e || [], !0));
  } catch (c) {
    console.error(c);
  }
};
function jt(t, r) {
  var e = mt(), c = mt();
  return vt(t) && Dt(t, function(g, d) {
    c.value && c.value.update(g);
  }), Tt(function() {
    e.value && (c.value = new It(e.value, vt(t) ? t.value : t, r));
  }), Yt(function() {
    c.value && c.value.destroy();
  }), [e, c];
}
let it;
const Ot = new Uint8Array(16);
function Ut() {
  if (!it && (it = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !it))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return it(Ot);
}
const _ = [];
for (let t = 0; t < 256; ++t)
  _.push((t + 256).toString(16).slice(1));
function Pt(t, r = 0) {
  return _[t[r + 0]] + _[t[r + 1]] + _[t[r + 2]] + _[t[r + 3]] + "-" + _[t[r + 4]] + _[t[r + 5]] + "-" + _[t[r + 6]] + _[t[r + 7]] + "-" + _[t[r + 8]] + _[t[r + 9]] + "-" + _[t[r + 10]] + _[t[r + 11]] + _[t[r + 12]] + _[t[r + 13]] + _[t[r + 14]] + _[t[r + 15]];
}
const $t = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), wt = {
  randomUUID: $t
};
function qt(t, r, e) {
  if (wt.randomUUID && !t)
    return wt.randomUUID();
  t = t || {};
  const c = t.random || (t.rng || Ut)();
  return c[6] = c[6] & 15 | 64, c[8] = c[8] & 63 | 128, Pt(c);
}
function Ft(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var at = { exports: {} }, Ht = at.exports, bt;
function _t() {
  return bt || (bt = 1, function(t, r) {
    (function(e, c) {
      t.exports = c();
    })(Ht, function() {
      var e = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, c = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, g = /\d/, d = /\d\d/, o = /\d\d?/, D = /\d*[^-_:/,()\s\d]+/, M = {}, h = function(a) {
        return (a = +a) + (a > 68 ? 1900 : 2e3);
      }, y = function(a) {
        return function(i) {
          this[a] = +i;
        };
      }, O = [/[+-]\d\d:?(\d\d)?|Z/, function(a) {
        (this.zone || (this.zone = {})).offset = function(i) {
          if (!i || i === "Z") return 0;
          var s = i.match(/([+-]|\d\d)/g), u = 60 * s[1] + (+s[2] || 0);
          return u === 0 ? 0 : s[0] === "+" ? -u : u;
        }(a);
      }], T = function(a) {
        var i = M[a];
        return i && (i.indexOf ? i : i.s.concat(i.f));
      }, L = function(a, i) {
        var s, u = M.meridiem;
        if (u) {
          for (var I = 1; I <= 24; I += 1) if (a.indexOf(u(I, 0, i)) > -1) {
            s = I > 12;
            break;
          }
        } else s = a === (i ? "pm" : "PM");
        return s;
      }, k = { A: [D, function(a) {
        this.afternoon = L(a, !1);
      }], a: [D, function(a) {
        this.afternoon = L(a, !0);
      }], Q: [g, function(a) {
        this.month = 3 * (a - 1) + 1;
      }], S: [g, function(a) {
        this.milliseconds = 100 * +a;
      }], SS: [d, function(a) {
        this.milliseconds = 10 * +a;
      }], SSS: [/\d{3}/, function(a) {
        this.milliseconds = +a;
      }], s: [o, y("seconds")], ss: [o, y("seconds")], m: [o, y("minutes")], mm: [o, y("minutes")], H: [o, y("hours")], h: [o, y("hours")], HH: [o, y("hours")], hh: [o, y("hours")], D: [o, y("day")], DD: [d, y("day")], Do: [D, function(a) {
        var i = M.ordinal, s = a.match(/\d+/);
        if (this.day = s[0], i) for (var u = 1; u <= 31; u += 1) i(u).replace(/\[|\]/g, "") === a && (this.day = u);
      }], w: [o, y("week")], ww: [d, y("week")], M: [o, y("month")], MM: [d, y("month")], MMM: [D, function(a) {
        var i = T("months"), s = (T("monthsShort") || i.map(function(u) {
          return u.slice(0, 3);
        })).indexOf(a) + 1;
        if (s < 1) throw new Error();
        this.month = s % 12 || s;
      }], MMMM: [D, function(a) {
        var i = T("months").indexOf(a) + 1;
        if (i < 1) throw new Error();
        this.month = i % 12 || i;
      }], Y: [/[+-]?\d+/, y("year")], YY: [d, function(a) {
        this.year = h(a);
      }], YYYY: [/\d{4}/, y("year")], Z: O, ZZ: O };
      function E(a) {
        var i, s;
        i = a, s = M && M.formats;
        for (var u = (a = i.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(F, P, U) {
          var v = U && U.toUpperCase();
          return P || s[U] || e[U] || s[v].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(p, f, n) {
            return f || n.slice(1);
          });
        })).match(c), I = u.length, Y = 0; Y < I; Y += 1) {
          var S = u[Y], l = k[S], w = l && l[0], z = l && l[1];
          u[Y] = z ? { regex: w, parser: z } : S.replace(/^\[|\]$/g, "");
        }
        return function(F) {
          for (var P = {}, U = 0, v = 0; U < I; U += 1) {
            var p = u[U];
            if (typeof p == "string") v += p.length;
            else {
              var f = p.regex, n = p.parser, b = F.slice(v), m = f.exec(b)[0];
              n.call(P, m), F = F.replace(m, "");
            }
          }
          return function(x) {
            var A = x.afternoon;
            if (A !== void 0) {
              var C = x.hours;
              A ? C < 12 && (x.hours += 12) : C === 12 && (x.hours = 0), delete x.afternoon;
            }
          }(P), P;
        };
      }
      return function(a, i, s) {
        s.p.customParseFormat = !0, a && a.parseTwoDigitYear && (h = a.parseTwoDigitYear);
        var u = i.prototype, I = u.parse;
        u.parse = function(Y) {
          var S = Y.date, l = Y.utc, w = Y.args;
          this.$u = l;
          var z = w[1];
          if (typeof z == "string") {
            var F = w[2] === !0, P = w[3] === !0, U = F || P, v = w[2];
            P && (v = w[2]), M = this.$locale(), !F && v && (M = s.Ls[v]), this.$d = function(b, m, x, A) {
              try {
                if (["x", "X"].indexOf(m) > -1) return new Date((m === "X" ? 1e3 : 1) * b);
                var C = E(m)(b), $ = C.year, R = C.month, W = C.day, N = C.hours, Z = C.minutes, ut = C.seconds, H = C.milliseconds, G = C.zone, J = C.week, X = /* @__PURE__ */ new Date(), Q = W || ($ || R ? 1 : X.getDate()), K = $ || X.getFullYear(), rt = 0;
                $ && !R || (rt = R > 0 ? R - 1 : X.getMonth());
                var nt, st = N || 0, ct = Z || 0, dt = ut || 0, lt = H || 0;
                return G ? new Date(Date.UTC(K, rt, Q, st, ct, dt, lt + 60 * G.offset * 1e3)) : x ? new Date(Date.UTC(K, rt, Q, st, ct, dt, lt)) : (nt = new Date(K, rt, Q, st, ct, dt, lt), J && (nt = A(nt).week(J).toDate()), nt);
              } catch {
                return /* @__PURE__ */ new Date("");
              }
            }(S, z, l, s), this.init(), v && v !== !0 && (this.$L = this.locale(v).$L), U && S != this.format(z) && (this.$d = /* @__PURE__ */ new Date("")), M = {};
          } else if (z instanceof Array) for (var p = z.length, f = 1; f <= p; f += 1) {
            w[1] = z[f - 1];
            var n = s.apply(this, w);
            if (n.isValid()) {
              this.$d = n.$d, this.$L = n.$L, this.init();
              break;
            }
            f === p && (this.$d = /* @__PURE__ */ new Date(""));
          }
          else I.call(this, Y);
        };
      };
    });
  }(at)), at.exports;
}
var Rt = _t();
const Xt = /* @__PURE__ */ Ft(Rt);
export {
  Xt as c,
  qt as v,
  jt as z
};
